export default {
  autoplay: false,
  controls: true,
  crossOrigin: "anonymous",
  currentTime: 0,
  defaultMuted: false,
  defaultPlaybackRate: 1,
  download: false,
  height: null,
  loop: false,
  mediaGroup: 'videoact',
  muted: false,
  playbackRate: 1,
  preload: false,
  ratio: 1.777,
  src: '',
  volume: 1,
  width: null,
}